var _defs, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPycharm = function SvgPycharm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "pycharm_svg__a",
    x1: 7.621,
    x2: 61.248,
    y1: 64.719,
    y2: 39.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#00D886"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#F0EB18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pycharm_svg__b",
    x1: 60.019,
    x2: 1.313,
    y1: 59.778,
    y2: 1.072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F0EB18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#00C4F4"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00D886",
    d: "m5.82 48.051.001 11.876a4.07 4.07 0 0 0 4.073 4.072H21.4c1.19 0 2.319-.52 3.093-1.422l32.709-38.162c.633-.738.98-1.678.98-2.65V9.889a4.073 4.073 0 0 0-4.072-4.073H42.6c-1.188 0-2.318.52-3.092 1.422L6.799 45.4a4.07 4.07 0 0 0-.98 2.651"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pycharm_svg__a)",
    d: "M5.818 49.483v10.446a4.073 4.073 0 0 0 4.073 4.073h13.093q.289 0 .576-.04l36.944-5.278A4.07 4.07 0 0 0 64 54.652V38.979a4.073 4.073 0 0 0-4.074-4.073l-18.538.005c-.438 0-.872.07-1.287.209L8.603 45.62a4.07 4.07 0 0 0-2.785 3.863"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pycharm_svg__b)",
    d: "M0 4.073V38.04c0 1.63.971 3.102 2.468 3.743l37.49 16.069c.508.216 1.054.329 1.605.329h18.364A4.073 4.073 0 0 0 64 54.109V36.143c0-.804-.238-1.591-.685-2.26L41.912 1.812A4.07 4.07 0 0 0 38.525.003L4.073 0A4.073 4.073 0 0 0 0 4.073"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M52 12H12v40h40z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M23.536 16.968h-6.44v15.005h2.926v-5.67h3.43q1.606 0 2.818-.579 1.222-.59 1.876-1.65c.443-.708.664-1.544.664-2.466q0-1.381-.654-2.433-.643-1.05-1.843-1.629-1.2-.578-2.777-.578m1.093 6.635q-.547.268-1.286.268H20.02V19.4h3.323q.739 0 1.286.278.557.268.857.772c.2.328.3.729.3 1.18q0 .675-.3 1.189-.3.503-.857.782",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M33.382 31.223q1.748 1.007 3.902 1.008v-.001q1.822 0 3.344-.675a6.84 6.84 0 0 0 2.53-1.887 6.45 6.45 0 0 0 1.36-2.797h-3.065q-.3.814-.9 1.436a4 4 0 0 1-1.426.943 4.9 4.9 0 0 1-1.822.333q-1.329 0-2.4-.665a4.65 4.65 0 0 1-1.684-1.822q-.6-1.168-.6-2.625t.6-2.616a4.64 4.64 0 0 1 1.683-1.833q1.072-.664 2.401-.664a4.9 4.9 0 0 1 1.822.332q.836.332 1.426.954.6.612.9 1.426h3.066a6.4 6.4 0 0 0-1.362-2.787 6.8 6.8 0 0 0-2.53-1.897q-1.522-.675-3.343-.675-2.155 0-3.902 1.018a7.24 7.24 0 0 0-2.744 2.787q-.997 1.768-.997 3.955 0 2.186.997 3.966a7.35 7.35 0 0 0 2.744 2.786M16.994 44.001h16v3h-16z"
  })));
};
export default SvgPycharm;